// extracted by mini-css-extract-plugin
export default {"collapseOuter":"collapse_collapseOuter__AG9j6"};